"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPostSportDigestTimeDto = instanceOfPostSportDigestTimeDto;
exports.PostSportDigestTimeDtoFromJSON = PostSportDigestTimeDtoFromJSON;
exports.PostSportDigestTimeDtoFromJSONTyped = PostSportDigestTimeDtoFromJSONTyped;
exports.PostSportDigestTimeDtoToJSON = PostSportDigestTimeDtoToJSON;
exports.PostSportDigestTimeDtoToJSONTyped = PostSportDigestTimeDtoToJSONTyped;
var DigestCopyDto_1 = require("./DigestCopyDto");
/**
 * Check if a given object implements the PostSportDigestTimeDto interface.
 */
function instanceOfPostSportDigestTimeDto(value) {
    if (!('question' in value) || value['question'] === undefined)
        return false;
    if (!('freeSectionLabel' in value) || value['freeSectionLabel'] === undefined)
        return false;
    if (!('proSectionLabel' in value) || value['proSectionLabel'] === undefined)
        return false;
    if (!('championSectionLabel' in value) || value['championSectionLabel'] === undefined)
        return false;
    if (!('freeTimeCodes' in value) || value['freeTimeCodes'] === undefined)
        return false;
    if (!('proTimeCodes' in value) || value['proTimeCodes'] === undefined)
        return false;
    if (!('championTimeCodes' in value) || value['championTimeCodes'] === undefined)
        return false;
    if (!('defaultTimeCode' in value) || value['defaultTimeCode'] === undefined)
        return false;
    if (!('required' in value) || value['required'] === undefined)
        return false;
    return true;
}
function PostSportDigestTimeDtoFromJSON(json) {
    return PostSportDigestTimeDtoFromJSONTyped(json, false);
}
function PostSportDigestTimeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'question': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['question']),
        'freeSectionLabel': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['freeSectionLabel']),
        'proSectionLabel': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['proSectionLabel']),
        'championSectionLabel': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['championSectionLabel']),
        'freeTimeCodes': json['freeTimeCodes'],
        'proTimeCodes': json['proTimeCodes'],
        'championTimeCodes': json['championTimeCodes'],
        'defaultTimeCode': json['defaultTimeCode'],
        'defaultChampionTimeCode': json['defaultChampionTimeCode'] == null ? undefined : json['defaultChampionTimeCode'],
        'required': json['required'],
    };
}
function PostSportDigestTimeDtoToJSON(json) {
    return PostSportDigestTimeDtoToJSONTyped(json, false);
}
function PostSportDigestTimeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'question': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['question']),
        'freeSectionLabel': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['freeSectionLabel']),
        'proSectionLabel': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['proSectionLabel']),
        'championSectionLabel': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['championSectionLabel']),
        'freeTimeCodes': value['freeTimeCodes'],
        'proTimeCodes': value['proTimeCodes'],
        'championTimeCodes': value['championTimeCodes'],
        'defaultTimeCode': value['defaultTimeCode'],
        'defaultChampionTimeCode': value['defaultChampionTimeCode'],
        'required': value['required'],
    };
}
